import * as z from "zod/v4";

export const exchangeShopifyOAuthCode = {
  name: "exchangeShopifyOAuthCode" as const,
  input: z.object({
    code: z.string(),
    shop: z.string(),
    hmac: z.string(),
    state: z.string(),
    rawParams: z.record(z.string(), z.string()),
  }),
  output: z.object({
    success: z.boolean(),
    redirectUrl: z.string().nullable(),
  }),
};
